export default
	{
		company:
			[{
				title: "CompanyAdd",
				question: "HowToAddCompany",
				answerUrl: [
					{
						title: "CompanyAddWithExcel",
						question: "HowToAddCompanyWithExcel",
						steps: [
							{
								imageSrc: "https://g4full.com/assets/usage/MatchStock-8.png",
								index: 0,
								markers: [
									{ x1: 10, y1: 170, x2: -150, y2: 170, info: "1 - Excel ile Stok Eşleme işlemleri yapmak için öncelikle 'Stok Tanımları' menüsüne giriş yapınız" },
									{ x1: 470, y1: 170, x2: 610, y2: 170, info: "2 - 'Toplu İşlemler' alanından Stok Eşleştir'e tıklayarak ilgili panelin açılmasını sağlayın" },
								],
							},
							{
								imageSrc: "https://g4full.com/assets/usage/MatchStock-4.png",
								index: 0,
								markers: [
									{ x1: 280, y1: 50, x2: 370, y2: 50, info: "3 - Müşteri seçimi yapın" },
									{ x1: 390, y1: 210, x2: 490, y2: 210, info: "4 - Excel ile Ekle'ye tıklayın" },
								],
							},
							{
								imageSrc: "https://g4full.com/assets/usage/MatchStock-6.png",
								index: 1,
								markers: [
									{ x1: -300, y1: 170, x2: -170, y2: 170, info: "5 - Dosyayı yükleyin" },
									{ x1: 210, y1: 400, x2: 210, y2: 340, info: "6 - Ekleye tıklayın" },
								],
							},
							{
								imageSrc: "https://g4full.com/assets/usage/MatchStock-5.png",
								index: 2,
								markers: [
									{ x1: 70, y1: 300, x2: 180, y2: 300, info: "7 - Dosya seçiniz kısmı onaylandıktan ve Liste görüntülendikten sonra işlemi onaylayabilirsiniz" },
								],
							},
						]
					},

				],

			},{
				title: "MarketplaceAdd",
				question: "HowToAddMarketplace",
				answerUrl: [
					{
						title: "MarketplaceWithExcel",
						question: "HowToAddMarketplaceWithExcel",
						steps: [
							{
								imageSrc: "https://g4full.com/assets/usage/MatchStock-8.png",
								index: 0,
								markers: [
									{ x1: 10, y1: 170, x2: -150, y2: 170, info: "1 - Excel ile Stok Eşleme işlemleri yapmak için öncelikle 'Stok Tanımları' menüsüne giriş yapınız" },
									{ x1: 470, y1: 170, x2: 610, y2: 170, info: "2 - 'Toplu İşlemler' alanından Stok Eşleştir'e tıklayarak ilgili panelin açılmasını sağlayın" },
								],
							},
							{
								imageSrc: "https://g4full.com/assets/usage/MatchStock-4.png",
								index: 0,
								markers: [
									{ x1: 280, y1: 50, x2: 370, y2: 50, info: "3 - Müşteri seçimi yapın" },
									{ x1: 390, y1: 210, x2: 490, y2: 210, info: "4 - Excel ile Ekle'ye tıklayın" },
								],
							},
							{
								imageSrc: "https://g4full.com/assets/usage/MatchStock-6.png",
								index: 1,
								markers: [
									{ x1: -300, y1: 170, x2: -170, y2: 170, info: "5 - Dosyayı yükleyin" },
									{ x1: 210, y1: 400, x2: 210, y2: 340, info: "6 - Ekleye tıklayın" },
								],
							},
							{
								imageSrc: "https://g4full.com/assets/usage/MatchStock-5.png",
								index: 2,
								markers: [
									{ x1: 70, y1: 300, x2: 180, y2: 300, info: "7 - Dosya seçiniz kısmı onaylandıktan ve Liste görüntülendikten sonra işlemi onaylayabilirsiniz" },
								],
							},
						]
					},

				],

			},
			],
		stock: [
			{
				title: "StockAdd",
				question: "HowToAddStock",
				answerUrl: [
					{
						title: "StockAddWithExcel",
						question: "HowToAddStockWithExcel",
						steps: [
							{
								imageSrc: "https://g4full.com/assets/usage/MatchStock-8.png",
								index: 0,
								markers: [
									{ x1: 10, y1: 170, x2: -150, y2: 170, info: "1 - Excel ile Stok Eşleme işlemleri yapmak için öncelikle 'Stok Tanımları' menüsüne giriş yapınız" },
									{ x1: 470, y1: 170, x2: 610, y2: 170, info: "2 - 'Toplu İşlemler' alanından Stok Eşleştir'e tıklayarak ilgili panelin açılmasını sağlayın" },
								],
							},
							{
								imageSrc: "https://g4full.com/assets/usage/MatchStock-4.png",
								index: 0,
								markers: [
									{ x1: 280, y1: 50, x2: 370, y2: 50, info: "3 - Müşteri seçimi yapın" },
									{ x1: 390, y1: 210, x2: 490, y2: 210, info: "4 - Excel ile Ekle'ye tıklayın" },
								],
							},
							{
								imageSrc: "https://g4full.com/assets/usage/MatchStock-6.png",
								index: 1,
								markers: [
									{ x1: -300, y1: 170, x2: -170, y2: 170, info: "5 - Dosyayı yükleyin" },
									{ x1: 210, y1: 400, x2: 210, y2: 340, info: "6 - Ekleye tıklayın" },
								],
							},
							{
								imageSrc: "https://g4full.com/assets/usage/MatchStock-5.png",
								index: 2,
								markers: [
									{ x1: 70, y1: 300, x2: 180, y2: 300, info: "7 - Dosya seçiniz kısmı onaylandıktan ve Liste görüntülendikten sonra işlemi onaylayabilirsiniz" },
								],
							},
						]
					},
				],
			}, {
				title: "MatchedStockAdd",
				question: "HowToAddMatchedStock",
				answerUrl: [
					{
						title: "MatchedStockAddWithExcel",
						question: "HowToAddStockWithExcel",
						steps: [
							{
								imageSrc: "https://g4full.com/assets/usage/MatchStock-8.png",
								index: 0,
								markers: [
									{ x1: 10, y1: 170, x2: -150, y2: 170, info: "1 - Excel ile Stok Eşleme işlemleri yapmak için öncelikle 'Stok Tanımları' menüsüne giriş yapınız" },
									{ x1: 470, y1: 170, x2: 610, y2: 170, info: "2 - 'Toplu İşlemler' alanından Stok Eşleştir'e tıklayarak ilgili panelin açılmasını sağlayın" },
								],
							},
							{
								imageSrc: "https://g4full.com/assets/usage/MatchStock-4.png",
								index: 0,
								markers: [
									{ x1: 280, y1: 50, x2: 370, y2: 50, info: "3 - Müşteri seçimi yapın" },
									{ x1: 390, y1: 210, x2: 490, y2: 210, info: "4 - Excel ile Ekle'ye tıklayın" },
								],
							},
							{
								imageSrc: "https://g4full.com/assets/usage/MatchStock-6.png",
								index: 1,
								markers: [
									{ x1: -300, y1: 170, x2: -170, y2: 170, info: "5 - Dosyayı yükleyin" },
									{ x1: 210, y1: 400, x2: 210, y2: 340, info: "6 - Ekleye tıklayın" },
								],
							},
							{
								imageSrc: "https://g4full.com/assets/usage/MatchStock-5.png",
								index: 2,
								markers: [
									{ x1: 70, y1: 300, x2: 180, y2: 300, info: "7 - Dosya seçiniz kısmı onaylandıktan ve Liste görüntülendikten sonra işlemi onaylayabilirsiniz" },
								],
							},
						]
					},

				],
			}
		]


	}
